import { createContext, useContext } from 'react'

export interface FormContextValue {
  requiredAttribute?: boolean
}

export const FormContext = createContext<FormContextValue>({
  requiredAttribute: false,
})

export const useFormContext = () => {
  const context = useContext(FormContext)
  return context
}
